













import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';

import { BillingDetails } from '@/data/web-api-client';

@Component({
  components: {
    cCard,
  },
})
export default class BillingDetailsCard extends Vue {
  @Prop()
  public billingDetails?: BillingDetails;

  showAll: boolean = false;

  mounted() {}
}
